/* eslint-disable */
import * as THREE from 'three'
import { useRef, forwardRef } from "react";
import {  Canvas, useThree, useFrame } from '@react-three/fiber'
import useRefs from 'react-use-refs'
import { Environment, Lightformer, ContactShadows,ScrollControls, useScroll, OrbitControls, Html, Image } from '@react-three/drei'
import { Effects } from './Effects'
import { Lamborghini } from './Lamborghini'



const rsqw = (t, delta = 0.1, a = 1, f = 1 / (2 * Math.PI)) => (a / Math.atan(1 / delta)) * Math.atan(Math.sin(2 * Math.PI * t * f) / delta)


export default function App() {
  
  return (
    <>
    
    <Canvas gl={{ logarithmicDepthBuffer: true, antialias: true }} dpr={[1, 1.7]} camera={{ position: [18.78, 4.04, 27.58], fov: 25 }}>
      
      

      <color attach="background" args={['#111111']}/>
      
      {/* <Lamborghini rotation={[0, 0, 0]} scale={0.02} position={[0, -1.6, 0]}></Lamborghini> */}
      

      <hemisphereLight intensity={1} />
      
      
      <Environment frames={Infinity} resolution={512}>
        {/* Ceiling */}
        {/* <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, -9]} scale={[10, 1, 1]} /> */}
        {/* <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, -6]} scale={[10, 1, 1]} /> */}
        <MovingSpots />

        <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, -3]} scale={[10, 1, 1]} />
        <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, 0]} scale={[10, 1, 1]} />
        <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, 3]} scale={[10, 1, 1]} />
        <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, 6]} scale={[10, 1, 1]} />
        {/* <Lightformer intensity={2} rotation-x={Math.PI / 2} position={[0, 4, 9]} scale={[10, 1, 1]} /> */}
        {/* Sides */}
        <Lightformer intensity={2} rotation-y={Math.PI / 2} position={[-50, 2, 0]} scale={[100, 2, 1]} />
        <Lightformer intensity={2} rotation-y={-Math.PI / 2} position={[50, 2, 0]} scale={[100, 2, 1]} />
        {/* Key */}
        <Lightformer form="ring" color="red" intensity={10} scale={2} position={[-5, 0, 0]} onUpdate={(self) => self.lookAt(0, 0, 0)} />
        <Lightformer form="rect" color="red" intensity={10} scale={4} position={[5, 0, 0]} onUpdate={(self) => self.lookAt(0, 0, 0)} />
      </Environment>

      <Effects />
      <OrbitControls enablePan={true} enableZoom={false} minPolarAngle={Math.PI/2.2}  maxPolarAngle={Math.PI/2.2}/>
      <ScrollControls pages={3}>
        <Composition />
      </ScrollControls>
      <CameraRig />
     
    </Canvas>
    </>
    
    
  )
 
  
}


function Composition({ ...props }) {
  const scroll = useScroll()
  const { width, height } = useThree((state) => state.viewport)
  const [group, mbp16, left,top,top2,bot,bot2, left2, right, right2] = useRefs()
  
  useFrame((state, delta) => {
    const r1 = scroll.range(0 / 4, 1 / 4)
    const r2 = scroll.range(1 / 4, 1 / 4)
    const r3 = scroll.range(4 / 5, 1 / 5)
    // mbp16.current.rotation.x = Math.PI - (Math.PI / 2) * rsqw(r1) + r2 * 0.33
    // mbp14.current.rotation.x = Math.PI - (Math.PI / 2) * rsqw(r1) - r2 * 0.39
    group.current.rotation.y = THREE.MathUtils.damp(group.current.rotation.y, 2.2 * r2+(r3*2.2), 4, delta)
    // group.current.position.x = THREE.MathUtils.damp(group.current.position.x, (-width / 150) * r2, 4, delta)
    group.current.scale.x = group.current.scale.y = group.current.scale.z = THREE.MathUtils.damp(group.current.scale.z, 0.8 + 0.24 * (1 - rsqw(r1+r2+r3)), 4, delta)
    // keyLight.current.position.set(0.25 + -15 * (1 - r1), 4 + 11 * (1 - r1), 3 + 2 * (1 - r1))
    left.current.classList.toggle('show', r2)
    left2.current.classList.toggle('show', r2)
    right.current.classList.toggle('show', r2)
    right2.current.classList.toggle('show', r2)
    left.current.classList.toggle('hide', r3)
    left2.current.classList.toggle('hide', r3)
    right.current.classList.toggle('hide', r3)
    right2.current.classList.toggle('hide', r3)
    top.current.classList.toggle('show', r3)
    top2.current.classList.toggle('show', r3)
    bot.current.classList.toggle('show', r3)
    bot2.current.classList.toggle('show', r3)
    
  })
  return (
    <>
      <Tag ref={top} position={[-2.5, -4.5, 0]} image2='/icons8-wheel-100.png' head2="WHEELBASE" stat2="2710" expl2={`MM`} />
      <Tag ref={top2} position={[3.25, -3.7, 0]} image2='/icons8-weight-kg-100.png' head2="CURBWEIGHT" stat2="1598" expl2={`KG`} />
      <Tag ref={bot} position={[-10, -5.5, 0]} image2='/icons8-gearbox-96.png' head2="TRANSMISSION" stat2="7SPD" expl2={`MANUAL`} />
      <Tag ref={bot2} position={[8, -3, 0]} image2='/icons8-speedometer-100.png' head2="0.100KM/H" stat2="3.1S" expl2={`SECONDS`} />

      <group position={[0, -height / 10.5, 0]}>
      <Tag ref={left} position={[-10, 2.5, 0]} image='/icons8-engine-100.png' head="ENGINE" stat="6.2L" expl={`V8.SUPER CHARGED`} />
      <Tag ref={left2} position={[-11, -3, 0]} image='/icons8-gears-100.png' head="POWER" stat="650" expl={`HP`} />
      <Tag ref={right} position={[8, -1, 0]}  image='/icons8-lightning-bolt-100.png' head="TORQUE" stat="881" expl={`NM`} />
      <Tag ref={right2} position={[8, 3, 0]} image='/icons8-speedometer-100.png' head="TOP SPEED" stat="298" expl={`KM/H`} />
      </group>

      <group ref={group} position={[0, -height / 5.3, 0]} {...props}>
        
        <ContactShadows resolution={24} frames={1} position={[0, -.2, 0]} scale={50} blur={0.7} opacity={1} far={20} />
        <Image  url="/corvette-logo.png" transparent scale={2} position={[-7, -1, 0]} opacity={1} resolution={512} rotation={[Math.PI / 2.5,-Math.PI / 2 , Math.PI / 2.5]}/>
        <Lamborghini ref={mbp16} scale={0.02} ></Lamborghini>
        

        

        <mesh scale={3} position={[0, -.1, 0]} rotation={[-Math.PI / 2, 0, Math.PI / 2.5]}>
          <ringGeometry args={[0.97, 1, 100, 10]} />
          <meshStandardMaterial color="white" roughness={0.9} />
        </mesh>
        <mesh scale={15} position={[0, .1, 0]} rotation={[-Math.PI / 2, 0, Math.PI / 2.5]}>
          <ringGeometry args={[0.97, 1, 100, 10]} />
          <meshStandardMaterial color="RED" roughness={0.75} />
        </mesh>
    
      
      </group>
    </>
  )
}

const Tag = forwardRef(({ image,image2, head, head2,stat,stat2,expl2, expl, ...props }, ref) => {
  return (
    <Html ref={ref} className="data" center {...props}>
      <img src={image} style={{marginTop:'0px'}} width='50px'></img>
      <img src={image2} style={{marginTop:'30px', left:0}} width='30px'></img>
      <div style={{ margin: 0, padding: 0, fontSize: '1em', fontWeight: 400, letterSpacing: '0.05em', color: '#ffffff',fontFamily:'Grand Sport'}}>{head}</div>
      <div style={{ margin: 0, padding: 0, fontSize: '0.8em', fontWeight: 100, lineHeight:'2.5em', letterSpacing: '0.2em', color: '#ffffff',fontFamily:'monument', height:0}}>{head2}</div>
      <h1 style={{ margin: 0, padding: 0, fontSize: '4em', fontWeight: 400, letterSpacing: '0.05em', color: '#ffffff'  }}>{stat}</h1>
      <h2 style={{ margin: 0, padding: 0, fontSize: '1em', fontWeight: 100, letterSpacing: '0em',color: '#ED574B' }}>{expl}</h2>
      <h1 style={{ margin: 0, padding: 0, fontSize: '2em', fontWeight: 500, letterSpacing: '0.05em', color: '#ED574B'  }}>{stat2}</h1>
      <h2 style={{ margin: 0, padding: 0, fontSize: '.6em', fontWeight: 100, letterSpacing: '0.5em',color: '#ffffff' }}>{expl2}</h2>
      
    </Html>
  )
})

function CameraRig({ v = new THREE.Vector3() }) {
  return useFrame((state) => {
    const t = state.clock.elapsedTime *2
    state.camera.position.lerp(v.set(15+ Math.sin(t / 5), 0, 25 + Math.cos(t / 5)), 0.2)
    state.camera.lookAt(0, 0, 0)
  })
}

function MovingSpots({ positions = [2, 0, 2, 0] }) {
  const group2 = useRef()
  useFrame((state, delta) => (group2.current.position.z += delta * 15) > 60 && (group2.current.position.z = -60))
  return (
    <group rotation={[0, 0.5, 0]}>
      <group ref={group2}>
        {positions.map((x, i) => (
          <Lightformer  key={i} form="circle" intensity={2} rotation={[Math.PI / 2, 0, 0]} position={[x, 4, i * 4]} scale={[3, 1, 1]} />
        ))}
      </group>
    </group>
  )
}
